var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-list-group",
    _vm._l(_vm.order, function(product) {
      return _c(
        "b-list-group-item",
        { key: product.id, class: { deleted: product.deleted } },
        [
          _c(
            "h5",
            {
              directives: [
                {
                  name: "b-toggle",
                  rawName: "v-b-toggle",
                  value: "item-" + product.id,
                  expression: "'item-' + product.id"
                }
              ],
              staticClass: "mb-0"
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.brand) +
                  " - " +
                  _vm._s(product.name) +
                  " "
              ),
              _c("span", { staticClass: "count" }, [
                _vm._v(
                  _vm._s(product.count > 0 ? " × " + product.count + " шт" : "")
                )
              ])
            ]
          ),
          _vm._v(" "),
          product.product.components
            ? _c(
                "b-collapse",
                { attrs: { id: "item-" + product.id } },
                _vm._l(JSON.parse(product.product.components), function(
                  description
                ) {
                  return _c(
                    "b-card",
                    { key: description.title, attrs: { "no-body": "" } },
                    [
                      _c(
                        "p",
                        {
                          staticClass:
                            "d-flex justify-content-center marginForP"
                        },
                        [
                          _vm._v(
                            _vm._s(description.title) +
                              " : " +
                              _vm._s(description.weight)
                          )
                        ]
                      )
                    ]
                  )
                }),
                1
              )
            : _vm._e()
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e4edea8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e4edea8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CookOrderDetails.vue
// module id = null
// module chunks = 